import { render, staticRenderFns } from "./DirectPayments.vue?vue&type=template&id=3bdfceae"
import script from "./DirectPayments.vue?vue&type=script&lang=js"
export * from "./DirectPayments.vue?vue&type=script&lang=js"
import style0 from "./DirectPayments.vue?vue&type=style&index=0&id=3bdfceae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports